// @flow

import styles from './RefineChecklist.less';
import React from 'react';
import classnames from 'classnames';

import NavLink from 'src/components/NavLink/NavLink';

import { Text } from 'seek-style-guide/react';

type FilterFn = () => boolean;

type DefaultProps = {
  options: Array<*>,
  filter: FilterFn
};

type Props = DefaultProps & {
  options: Array<RefinementClassification>,
  path: string,
  childrenKey?: string,
  filter?: FilterFn,
  handleSelection: Function
};

const renderChecklist = function(
  props: Props,
  options,
  handleSelection,
  depth
) {
  const { path, childrenKey, filter } = props;

  const filteredOptions = options.filter(filter);

  return filteredOptions.length > 0 ? (
    <ul
      className={classnames({
        [styles.root]: true,
        [styles.root_isNested]: depth
      })}
    >
      {filteredOptions.map(option => (
        <li
          onClick={handleSelection}
          key={option.value}
          className={classnames({
            [styles.item]: true,
            [styles.item_isActive]: option.isActive,
            [styles.item_isAll]: option.type === 'all'
          })}
          data-automation={`item-depth-${depth}`}
        >
          <NavLink
            data-automation={`${option.type === 'all' ? 'all-' : ''}${
              option.value
            }`}
            location={{
              pathname: path,
              query: option.refineParams
            }}
            role="checkbox"
            aria-checked={option.isActive}
            aria-label={`${option.label} ${
              option.displayCount ? `${option.displayCount} jobs` : ''
            }`}
            className={styles.link}
          >
            <Text
              strong={option.isActive}
              className={styles.mobileOffset}
              data-automation="item-text"
            >
              {option.label}
            </Text>
          </NavLink>
          {option.displayCount ? (
            <Text
              strong={option.isActive}
              className={classnames(styles.count, styles.mobileOffset)}
            >
              {` ${option.displayCount}`}
            </Text>
          ) : null}
          {!option[childrenKey]
            ? null
            : renderChecklist(
                props,
                option[childrenKey],
                handleSelection,
                depth + 1
              )}
        </li>
      ))}
    </ul>
  ) : null;
};

class RefineChecklist extends React.PureComponent<Props> {
  static defaultProps: DefaultProps = {
    options: [], // damn flow and it's odd issue around default props.
    filter: () => true
  };

  handleSelection = (event: SyntheticInputEvent<*>) => {
    event.stopPropagation();
    this.props.handleSelection();
  };

  render() {
    return renderChecklist(
      this.props,
      this.props.options,
      this.handleSelection,
      0
    );
  }
}

export default RefineChecklist;
